var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2033 1.06419L6.99998 5.26752L2.79665 1.06419C2.37415 0.641689 1.69165 0.641689 1.26915 1.06419C0.846646 1.48669 0.846646 2.16919 1.26915 2.59169L6.24165 7.56419C6.66415 7.98669 7.34664 7.98669 7.76915 7.56419L12.7416 2.59169C13.1641 2.16919 13.1641 1.48669 12.7416 1.06419C12.3191 0.652523 11.6258 0.641689 11.2033 1.06419Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDownArrow);
export default __webpack_public_path__ + "static/media/dropDownArrow.9d63dd4abd561adc16c4521c0e9ed877.svg";
export { ForwardRef as ReactComponent };